import { apiClient } from './apiClient';

export const notificationService = {
  /**
   * Get paginated notifications
   * @param {number} page - Page number (0-indexed)
   * @param {number} size - Page size
   */
  async getNotifications(page = 0, size = 20) {
    return apiClient.get(`/api/notifications?page=${page}&size=${size}`);
  },

  /**
   * Get unread notifications
   */
  async getUnreadNotifications() {
    return apiClient.get('/api/notifications/unread');
  },

  /**
   * Get unread notification count
   */
  async getUnreadCount() {
    return apiClient.get('/api/notifications/unread/count');
  },

  /**
   * Mark a notification as read
   * @param {number} id - Notification ID
   */
  async markAsRead(id) {
    return apiClient.post(`/api/notifications/${id}/read`);
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead() {
    return apiClient.post('/api/notifications/read-all');
  },

  /**
   * Get notification preferences
   */
  async getPreferences() {
    return apiClient.get('/api/notifications/preferences');
  },

  /**
   * Update notification preferences
   * @param {Object} preferences - Notification preferences
   */
  async updatePreferences(preferences) {
    return apiClient.put('/api/notifications/preferences', preferences);
  },
};

// Notification type labels for display
export const NOTIFICATION_TYPE_LABELS = {
  WORK_ORDER_CREATED: 'Work Order Created',
  WORK_ORDER_ASSIGNED: 'Work Order Assigned',
  WORK_ORDER_UPDATED: 'Work Order Updated',
  WORK_ORDER_COMPLETED: 'Work Order Completed',
  WORK_ORDER_OVERDUE: 'Work Order Overdue',
  PM_SCHEDULE_DUE: 'PM Schedule Due',
  PM_SCHEDULE_OVERDUE: 'PM Schedule Overdue',
  ASSET_DOWN: 'Asset Down',
  ASSET_MAINTENANCE_DUE: 'Asset Maintenance Due',
  COMPONENT_DUE: 'Component Replacement Due',
  COMPONENT_OVERDUE: 'Component Overdue',
  SUBSCRIPTION_TRIAL_ENDING: 'Trial Ending',
  SUBSCRIPTION_EXPIRED: 'Subscription Expired',
  SUBSCRIPTION_RENEWED: 'Subscription Renewed',
  SYSTEM_ANNOUNCEMENT: 'System Announcement',
  WELCOME: 'Welcome',
  ACCOUNT_UPDATE: 'Account Update',
  SECURITY_ALERT: 'Security Alert',
};

// Notification type icons (Lucide icon names)
export const NOTIFICATION_TYPE_ICONS = {
  WORK_ORDER_CREATED: 'ClipboardList',
  WORK_ORDER_ASSIGNED: 'UserCheck',
  WORK_ORDER_UPDATED: 'RefreshCw',
  WORK_ORDER_COMPLETED: 'CheckCircle',
  WORK_ORDER_OVERDUE: 'AlertTriangle',
  PM_SCHEDULE_DUE: 'Calendar',
  PM_SCHEDULE_OVERDUE: 'CalendarX',
  ASSET_DOWN: 'XCircle',
  ASSET_MAINTENANCE_DUE: 'Wrench',
  COMPONENT_DUE: 'Package',
  COMPONENT_OVERDUE: 'PackageX',
  SUBSCRIPTION_TRIAL_ENDING: 'Clock',
  SUBSCRIPTION_EXPIRED: 'CreditCard',
  SUBSCRIPTION_RENEWED: 'CheckCircle',
  SYSTEM_ANNOUNCEMENT: 'Megaphone',
  WELCOME: 'PartyPopper',
  ACCOUNT_UPDATE: 'User',
  SECURITY_ALERT: 'Shield',
};
